import React, { useEffect, useState, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import { pdfjs, Document, Page } from "react-pdf";
import HTMLFlipBook from "react-pageflip";


// PDF Worker
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// STATIC DATA
const PRODUCT_DATA_MAP = {
  "2": [
    {
      product_image_name: "Melamine Catalogue Part 1",
      product_image: "MELAMINE-1.pdf",
      poster_image: "poster.png",
    },
    // {
    //   product_image_name: "Melamine Catalogue Part 2",
    //   product_image: "Melamine Catalogue.pdf",
    //   poster_image: "poster2.jpg",
    // }
  ],
  "25": [
    {
      product_image_name: "PORCELAIN CATALOGUE 1",
      product_image: "PORCELAIN-1.pdf",
      poster_image: "poster3.png",
    },
    // {
    //   product_image_name: "SACHI PORCELAIN CATALOGUE 2",
    //   product_image: "SACHI PORCELAIN CATALOGUE 2.pdf",
    //   poster_image: "poster4.jpg",
    // }
  ],
  "1": [
    {
      product_image_name: "FINE TABLEWARE CATALOGUE 1",
      product_image: "FINE TABLEWARE.pdf",
      poster_image: "poster5.png",
    },
  ],
  "3": [
    {
      product_image_name: "Acrylic Crockery",
      product_image: "Minimal Aesthetic Fashion Jewelry Catalogue.pdf",
      poster_image: "Minimal Aesthetic.jpg",
    },
  ],
  "main_6": [
    {
      product_image_name: "Electric Equipments",
      product_image: "electronic_equipment.pdf",
      poster_image: "electronic equipment.png",
    },
  ],
  "main_2": [
    {
      product_image_name: "Cutlery",
      product_image: "Final_spoon.pdf",
      poster_image: "Cutlery.jpeg",
    },
  ],
  "main_3": [
    {
      product_image_name: "Glassware",
      product_image: "Final_Glassware.pdf",
      poster_image: "Glassware.jpeg",
    },
  ],
  "main_9": [
    {
      product_image_name: "Food Packaging",
      product_image: "Food_packaging.pdf",
      poster_image: "foodpackaging.jpg",
    },
  ],

  "main_4": [
    {
      product_image_name: "Presentation Tableware",
      product_image: "Final_Tableware.pdf",
      poster_image: "tableware.jpeg",
    },
  ],
  "main_5": [
    {
      product_image_name: "Catering Products",
      product_image: "Catering_products.pdf",
      poster_image: "catering_products.jpeg",
    },
  ],
   "main_7": [
    {
      product_image_name: "Chafing Dishes",
      product_image: "Final_cheffing_dishes.pdf",
      poster_image: "cheffing.jpeg",
    },
  ],
};


const ProductCatalogue = () => {
  const { id, name } = useParams();
  const history = useHistory();

  const bookRef = useRef(null);

  const [catalogues, setCatalogues] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null);

  const [numPages, setNumPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const mobileContainerRef = useRef(null);
  const PUBLIC_PATH = `/assets/pdf`;


  // Add a ready state
  const [bookReady, setBookReady] = useState(false);

  // Update onDocumentLoadSuccess
  const onDocumentLoadSuccess = (pdfDoc) => {
    setNumPages(pdfDoc.numPages);
    setBookReady(false); // reset on new PDF open

    pdfDoc.getPage(1).then((page) => {
      const viewport = page.getViewport({ scale: 1 });
      const ratio = viewport.width / viewport.height;

      const maxW = 700;
      const maxH = 750;

      let w, h;
      if (ratio > 1) {
        w = Math.min(maxW, maxH * ratio);
        h = w / ratio;
      } else {
        h = maxH;
        w = h * ratio;
      }

      setPageWidth(Math.round(w));
      setPageHeight(Math.round(h));
      setBookReady(true); // ✅ only now render flipbook
    }).catch((err) => {
      console.warn("Could not detect page size, using defaults", err);
      setBookReady(true); // fallback: render anyway with defaults
    });
  };

  // Inside ProductCatalogue.js
  useEffect(() => {
    const productPdfs = PRODUCT_DATA_MAP[id] || [];
    setCatalogues(productPdfs);
  }, [id]);

  // Handle resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

 

  // 🔥 force scroll to top after load
  setTimeout(() => {
    if (mobileContainerRef.current) {
      mobileContainerRef.current.scrollTop = 0;
    }
  }, 100);


  // Flipbook controls
  const nextButtonClick = () => {
    if (bookRef.current?.pageFlip()) {
      bookRef.current.pageFlip().flipNext();
    }
  };

  const prevButtonClick = () => {
    if (bookRef.current?.pageFlip()) {
      bookRef.current.pageFlip().flipPrev();
    }
  };

  // Download
  const handleDownload = (file) => {
    const link = document.createElement("a");
    link.href = `${PUBLIC_PATH}/${file}`;
    link.download = file;
    link.click();
  };

  // Add these state variables
  const [pageWidth, setPageWidth] = useState(550);
  const [pageHeight, setPageHeight] = useState(750);



  return (
    <main className="main-content bg-light">
      {/* HEADER */}
      {/* <section className="page-header catelogue-bg py-5 text-center bg-dark text-white">
        <div className="container">
          <h2 style={{ color: "white" }}>{name || "Product Catalogue"}</h2>
          <p className="text-muted">Digital Catalogue Library</p>
        </div>
      </section> */}

      {/* LIST */}
      <section className="py-5">
        <div className="container">
          <button
            onClick={() => history.goBack()}
            className="btn btn-outline-dark mb-4 btn-sm"
          >
            ← Back To Products
          </button>

          <div className="row justify-content-center">
            {catalogues.length > 0 ? (
              catalogues.map((item, index) => (
                <div className="col-md-4 mb-4" key={index}>
                  <div className="card p-3 text-center shadow-sm">

                    {/* Download Icon */}
                    <div style={{ position: "absolute", top: 10, right: 10, background: "white", padding: "6PX 6PX" }}>
                      <i
                        className="fa fa-download"
                        style={{ cursor: "pointer", fontSize: 22, color: "black" }}
                        onClick={() => handleDownload(item.product_image)}
                      />
                    </div>

                    <img
                      src={`${PUBLIC_PATH}/${item.poster_image}`}
                      alt=""
                      style={{
                        height: 200,
                        width: "100%",
                        objectFit: "cover",
                        borderRadius: 10,
                      }}
                    />

                    <h6 className="mt-3">{item.product_image_name}</h6>

                    <button
                      className="btn btn-primary mt-2"
                      onClick={() => {
                        setSelectedPdf({
                          url: `${PUBLIC_PATH}/${item.product_image}`,
                          name: item.product_image,
                        });

                        // 🔥 reset immediately
                        setTimeout(() => {
                          if (mobileContainerRef.current) {
                            mobileContainerRef.current.scrollTop = 0;
                          }
                        }, 0);
                      }}
                    >
                      View Catalogue
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <h5 className="text-center">No Catalogues Found</h5>
            )}
          </div>
        </div>
      </section>

     {/* MODAL VIEWER */}
{selectedPdf && (
  <div style={overlayStyle}>
    <div style={modalStyle}>

      {/* Header */}
      <div className="d-flex justify-content-between p-3 border-bottom">
        <strong>{selectedPdf.name}</strong>
        <button
          className="btn-primary px-2"
          onClick={() => {
            setSelectedPdf(null);
            setBookReady(false);
            setNumPages(0);
          }}
        >
          ✕
        </button>
      </div>


      

      {/* PDF Viewer */}
      <div style={bookContainerStyle}>
        <Document file={selectedPdf.url} onLoadSuccess={onDocumentLoadSuccess}>

          {numPages > 0 && (
            isMobile ? (
              // MOBILE VIEW
              <div
                ref={mobileContainerRef}
                style={{
                  height: "100%",
                  width: "100%",
                  overflowY: "auto",
                  WebkitOverflowScrolling: "touch",
                  padding: "10px"
                }}
              >
                {[...Array(numPages).keys()].map((p) => (
                  <div key={`mobile-${p}`} style={{ marginBottom: "15px" }}>
                    <Page
                      pageNumber={p + 1}
                      width={Math.min(window.innerWidth - 30, 500)}
                      renderAnnotationLayer={false}
                      renderTextLayer={false}
                    />
                  </div>
                ))}
              </div>
            ) : (
              // DESKTOP VIEW
              bookReady ? (
                <HTMLFlipBook
                  width={pageWidth}
                  height={pageHeight}
                  size="fixed"
                  minWidth={315}
                  maxWidth={1000}
                  minHeight={400}
                  maxHeight={1536}
                  drawShadow={true}
                  flippingTime={800}
                  usePortrait={false}
                  startPage={0}
                  showCover={true}
                  mobileScrollSupport={false}
                  className="sachi-flipbook"
                  ref={bookRef}
                  onFlip={(e) => setCurrentPage(e.data)}
                >
                  {[...Array(numPages).keys()].map((p) => (
                    <div key={p} className="page" data-density="hard">
                      <Page
                        pageNumber={p + 1}
                        width={pageWidth}
                        renderAnnotationLayer={false}
                        renderTextLayer={false}
                      />
                    </div>
                  ))}
                </HTMLFlipBook>
              ) : (
                // Loading spinner
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  color: "#fff"
                }}>
                  <span>Loading...</span>
                </div>
              )
            )
          )}

        </Document>
      </div>

      {/* Footer Controls */}
      {!isMobile && (
        <div className="p-3 d-flex justify-content-between align-items-center border-top bg-light">
          <button
            className="btn btn-primary px-4 py-2"
            onClick={prevButtonClick}
          >
            <i className="fa fa-arrow-left me-2"></i>
            Previous
          </button>

          <span className="fw-bold text-dark">
            Page {currentPage + 1} / {numPages}
          </span>

          <button
            className="btn btn-primary px-4 py-2"
            onClick={nextButtonClick}
          >
            Next
            <i className="fa fa-arrow-right ms-2"></i>
          </button>
        </div>
      )}

    </div>
  </div>
)}
      </main >
    );
  };
// STYLES
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.8)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const modalStyle = {
  width: "95%",
  height: "95%",
  background: "#fff",
  display: "flex",
  flexDirection: "column",
};

const bookContainerStyle = {
  flexGrow: 1,
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  backgroundColor: "#525659",
  padding: "20px",
  overflow: "auto",
}



export default ProductCatalogue;